import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import * as React from "react";
import { Button, useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import useNotify from "../../unit/useNotify";
import DialogApplicationBaseInfo from "../DialogApplicationBaseInfo";

export default function CustomCounterReminderDialog({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { appId, record } = props;
  const [open, setOpen] = React.useState(false);
  const refresh = useRefresh();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    refresh();
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Button
        id="btn-application-counter-reminder"
        label="Reminder"
        variant="contained"
        size="medium"
        color="primary"
        sx={{
          marginLeft: "10px",
          width: "120px",
          "&:hover": { bgcolor: "gray" },
        }}
        onClick={handleClickOpen}
      />
      <Dialog
        id="dialog-application-counter-reminder"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="sm"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const reqUrl = `email/reminder/counter`;
            const response = await sendRequest(reqUrl, {
              id: appId,
              data: {},
            });
            console.log("counter reminder response", response);
            if (
              response &&
              (response.status == "200" ||
                response.code == "200" ||
                response.code == 200)
            ) {
              if (typeof props?.handleCallBackRefreshMenu === "function") {
                props.handleCallBackRefreshMenu();
              }
              successNotify("Message sent successfully.");
              handleClose();
            } else {
              errorNotify(response?.message || "Data not saved!");
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            mb: 2,
            borderBottom: "1px solid #e5e5e5",
            color: "#465384",
            textTransform: "uppercase",
          }}
        >
          Reminder
        </DialogTitle>
        <DialogContent>
          <DialogApplicationBaseInfo appId={appId} record={record} />
          <DialogContentText>
            Send a message to remind the applicant {appId} to respond to the
            counter offer.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          <CustomButtonSubmit label="Reminder" color="primary" />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
